import React from "react";
import "./Footer.css";
import VisitorCount from "./VisitorCount";

// Import the MapComponent
import MapComponent from "./MapComponent";

// Import images from the assets folder
import pinIcon from "../assets/Pin1.webp";
import phoneIcon from "../assets/phone2.webp";
import mailIcon from "../assets/mail1.webp";
import facebookIcon from "../assets/facebook1.webp";
import tiktokIcon from "../assets/TiktokVector.webp"; // renamed from "TiktokRecVector white 2.webp"

const Footer = () => {
  return (
    <div className="footer">
      <div className="container flex">
        <footer>
          <div className="firstLine">
            <h2 className="lndnHouse">London House School of English, Chiang Mai</h2>
          </div>
          <div className="secondLine">
            <MapComponent />
            <div className="address-container">
              <img src={pinIcon} alt="pin" />
              <p>
                London House School of English <br />
                4 Soi.8 Sripoom Road., <br />
                Muang, Chiang Mai, Thailand 50200
              </p>
            </div>
            <div className="contact-container">
              <div className="phone-container">
                <img src={phoneIcon} alt="phone-number" />
                <p>053 218 948</p>
              </div>
              <div className="mail-container">
                <img src={mailIcon} alt="email" />
                <p>londonhousechiangmai@gmail.com</p>
              </div>
              <div className="facebook-container">
                <img src={facebookIcon} alt="facebook" />
                <p>www.facebook.com/londonhousecm</p>
              </div>
              <div className="tiktok-container">
                <img src={tiktokIcon} alt="tiktok" />
                <p>@londonhousechiangmai</p>
              </div>
            </div>
          </div>
          <VisitorCount />
        </footer>
      </div>
    </div>
  );
};

export default Footer;
